/* eslint-disable import/no-anonymous-default-export */
import { docodeHexResponse } from '../../_common/common.utils';
import OfficerLocationActionType from './officer-location-report.types';

const INITIAL_STATE = {
	getFieldOfficerListResponse: null,
	getFieldOfficerListRespArr: null,
	getFieldOfficerLocationResponse: null,
	getFieldOfficerLocationRespArr: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/*********  START GET FIELD OFFICER LIST  *********/
		case OfficerLocationActionType.GET_FIELD_OFFICER_LIST_SUCCESS:
			return {
				...state,
				getFieldOfficerListResponse: action.response,
				getFieldOfficerListRespArr: docodeHexResponse(
					action.response,
					'GetFieldOfficerListKey',
				),
			};

		case OfficerLocationActionType.GET_FIELD_OFFICER_LIST_FAILURE:
			return { ...state, getFieldOfficerListResponse: action.response };

		case OfficerLocationActionType.GET_FIELD_OFFICER_LIST_RESPONSE_CHANGED:
			return { ...state, getFieldOfficerListResponse: null };
		/*********  END GET FIELD OFFICER LIST  *********/

		/*********  START GET FIELD OFFICER LOCATION DETAILS  *********/
		case OfficerLocationActionType.GET_FIELD_OFFICER_LOCATION_SUCCESS:
			return {
				...state,

				getFieldOfficerLocationResponse: action.response,
				getFieldOfficerLocationRespArr: docodeHexResponse(
					action.response,
					'GetFieldOfficerLocationKey',
				),
			};
		case OfficerLocationActionType.GET_FIELD_OFFICER_LOCATION_FAILURE:
			return { ...state, getFieldOfficerLocationResponse: action.error };

		case OfficerLocationActionType.GET_FIELD_OFFICER_LOCATION_RESPONSE_CHANGED:
			return { ...state, getFieldOfficerLocationResponse: null };
		/*********  END GET FIELD OFFICER LOCATION DETAILS  *********/
		default:
			return state;
	}
};
